import {computed} from 'vue';
import {NavbarMode, type ModuleRuntimeConfig, type ModeConfig} from '@navbar-unlogged-types';
import {useRuntimeConfig} from '#imports';
import {useState} from '#imports';
import {readonlyState} from '@malt/utils';

export function useNavbarMode() {
    const runtimeConfig = useRuntimeConfig().public['@malt/nuxt-navbar-unlogged-module'];
    const moduleConfig = useState<ModuleRuntimeConfig>('navbar-unlogged-module-config', () => ({
        modes: (runtimeConfig.modes as ModeConfig[]) ?? [],
        defaultMode: runtimeConfig.defaultMode as NavbarMode,
    }));

    const selectedMode = useState<NavbarMode | undefined>('navbar-unlogged-selected-mode', () => moduleConfig.value.defaultMode);

    const currentModeConfig = computed((): ModeConfig | undefined => moduleConfig.value.modes!.find((mode) => mode.id === selectedMode.value));

    function switchMode(newMode: NavbarMode) {
        selectedMode.value = newMode;
    }

    const hasMultipleModes = computed(() => moduleConfig.value.modes && moduleConfig.value.modes.length > 1);

    return {
        // consts a-z
        config: readonlyState(moduleConfig),
        currentModeConfig,
        hasMultipleModes,
        selectedMode: readonlyState(selectedMode),
        // functions a-z
        switchMode,
    };
}
